import { Injectable } from '@angular/core';
import 'rxjs/add/operator/delay';

import { Apollo } from 'apollo-angular';
import { ApolloQueryResult } from 'apollo-client';


import { Observable } from 'rxjs/Observable';

import SearchArtists from '../../queries/artist-search.model';

@Injectable()
export class ArtistSearchService {

  public pagingObj: any = {
    'skip': 0,
    'limit': 30
  };

  constructor(private apollo: Apollo) {}

  public searchArtist(term: string): Observable<ApolloQueryResult<Object>> {
    return this.apollo.query({ query: SearchArtists, variables: { searchText: term, paging: this.pagingObj } })
      .map(({data}) => data)
      .catch((error) => {
        console.log('Search service error', error);
        throw error;
      });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/shared/services/artist-search.service.ts